export default __webpack_public_path__ + "static/media/whisper-evo.ff7744b0.jpg";